var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('yes-or-no-radio',{staticClass:"form-group",attrs:{"model":_vm.schema.value,"disabled":_vm.isDisabled}}),_c('comment',{attrs:{"schema":_vm.schema}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }